import * as React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";
import { cn } from "@/lib/utils";
const Slider = React.forwardRef<React.ElementRef<typeof SliderPrimitive.Root>, React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>>(({
  className,
  "aria-label": ariaLabel,
  ...props
}, ref) => (
  <SliderPrimitive.Root 
    ref={ref} 
    className={cn("relative flex w-full touch-none select-none items-center", className)} 
    aria-label={ariaLabel || "Slider"}
    {...props}
  >
    <SliderPrimitive.Track className="relative h-2.5 w-full grow overflow-hidden rounded-full bg-muted">
      <SliderPrimitive.Range className="absolute h-full bg-gradient-primary rounded-full" />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb 
      aria-label={ariaLabel || "Adjust value"}
      className="block h-5 w-5 rounded-full border-2 border-primary bg-card shadow-lg ring-offset-background transition-all duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:scale-110 hover:shadow-glow cursor-grab active:cursor-grabbing" 
    />
  </SliderPrimitive.Root>
));
Slider.displayName = SliderPrimitive.Root.displayName;
export { Slider };